export const projectsTypesOptions = [
  { value: 'medical', label: 'Médical' },
  { value: 'marketing', label: 'Marketing' },
];

export const tasksStatusOptions = [
  {
    label: 'A faire',
    value: 'todo',
  },
  {
    label: 'En cours',
    value: 'doing',
  },
  {
    label: 'Fait',
    value: 'done',
  },
];

export const formKeys = [
  { value: 'clinic', label: 'Clinique' },
  { value: 'diagnostic', label: 'Diagnostic' },
  { value: 'epidemiology', label: 'Epidemiologie' },
  { value: 'etiology', label: 'Etiologie' },
  { value: 'mechanisms', label: 'Mecanismes' },
  { value: 'treatment', label: 'Traitement' },
  { value: 'other', label: 'Autres' },
];

export const companyTypesOptions = [
  { value: 'laboratory', label: 'Laboratoire' },
  { value: 'company', label: 'Entreprise' },
];
